export default function Footer() {
  return (
    <section className="bg-dark text-light text-center">
      <div className="container">
        <div className="row pt-4">
          <p className="display-6 col-md-6">
            Fresh<strong>Goods</strong>
          </p>
          <p className="col-md-6 align-self-center">
            © 2020 Insert Name Here. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
}
